import React from 'react';
import { Select, Button, Divider } from 'antd';

/**
 * MailingListFilter component for filtering data by mailing lists
 * @param {Object} props - Component props
 */
const MailingListFilter = ({
  selectedMailingLists,
  mailingListOptions,
  loadingMailingLists,
  onMailingListsChange,
  onSelectAll,
  onDeselectAll
}) => {
  // Custom dropdown render for mailing lists select
  const dropdownRender = (menu) => (
    <div>
      <div style={{ padding: '16px', display: 'flex', justifyContent: 'space-between' }}>
        <Button 
          size="small" 
          type="primary" 
          onClick={onSelectAll}
          style={{ marginRight: '8px' }}
        >
          DeSelect All
        </Button>
        <Button 
          size="small" 
          onClick={onDeselectAll}
        >
          Select All
        </Button>
      </div>
      <Divider style={{ margin: '4px 0' }} />
      {menu}
    </div>
  );

  return (
    <div className="">
       <Select
        id="mailingListFilter"
        mode="multiple"
        value={selectedMailingLists}
        onChange={onMailingListsChange}
        options={[{ label: 'All Mailing Lists', value: 'all' }, ...mailingListOptions]}
        style={{ width: '100%' }}
        placeholder="Select Mailing Lists"
        loading={loadingMailingLists}
        dropdownRender={dropdownRender}
        maxTagCount="responsive"
      />
    </div>
  );
};

export default MailingListFilter;
